import React, { useState, useEffect } from 'react';

import { showLogin } from '@vkplay/eva';

import AuthContext from 'contexts/auth';

const Authorised: React.FC = ({ children }) => {
    const [user, setUser] = useState(window.VKPAppConfig.profile || {});
    const [isUnauthorized, setUnauthorized] = useState(false);

    useEffect(() => {
        window.VKPAppConfig.profile = user || {};
    }, [user]);

    function signOut() {
        setUser({});
    }

    function checkAuth(onSuccess, onFailure): boolean {
        if (!user.user_id) {
            if (typeof onFailure === 'function') {
                onFailure();
            }

            showLogin();

            return false;
        }

        if (typeof onSuccess === 'function') {
            onSuccess();
        }

        return true;
    }

    return (
        <AuthContext.Provider value={{
            user, isUnauthorized, setUser, checkAuth, signOut, setUnauthorized,
        }}
        >
            {children}
        </AuthContext.Provider>
    );
};

export default React.memo(Authorised);
